export enum DocTypes {
    LEGAL = 'legal',
    PROPOSITION = 'proposition',
    STORY = 'story',
};